import { ApiError } from './http/ApiError.ts';

/**
 * A plan limit reached on the plan of the person acting, so they can upgrade
 * (their own Your plan page helps); someone else's plan says whom to ask instead.
 */
export function isYourLimit(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.code === 'limit_reached' &&
    (err.details as { yours?: unknown } | null)?.yours === true
  );
}
